"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => { Sentry.captureException(error); }, [error]);
  return (
    <html lang="ru">
      <body>
        <h1>Не удалось загрузить страницу</h1>
        <button onClick={reset}>Попробовать снова</button>
      </body>
    </html>
  );
}
